export default {
    routeBusinessStockDeliveryResultView: {
        Basic: 'Outbound Account Information',
        Delivery: 'Outbound result Order No.',
        Outbound: 'Outbound logic warehouse code',
        Name: 'Outbound logic warehouse name',
        Logistics: 'Logistics',
        business: 'Logistics Business',
        Consignee: 'Full Name',
        Contact: 'Contact Number',
        Shipping: 'Shipping Address',
        Creation: 'Creation Time',
        Created: 'Created By',
        Associated: 'Related Documents',
        Doc: 'Logistics Number',
        notice: 'Outbound Notice Number',
        WMS: 'WMS Number',
        Product: 'Product Details',
        code: 'Product Code',
        SKU: 'SKU Name',
        SKUcode: 'SKU',
        Quantity: 'Quantity Shipped',
        Productname: 'Product Name',
        Shipped: 'Quantity Shipped',
    }
};
